const _version = "3.2.6"
function version() {
    return _version
}
export default version
